(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-plugin-chromecast"] = factory(require("mggp-player"));
	else
		root["mggp-plugin-chromecast"] = factory(root["mggp-player"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_mggp_player__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/mggp-plugin-chromecast.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/mggp-plugin-chromecast.js":
/*!***************************************!*\
  !*** ./src/mggp-plugin-chromecast.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @class MggpPluginChromecast
 */

function MggpPluginChromecast(player, options) {
	var Plugin = __webpack_require__(/*! mggp-player */ "mggp-player").Plugin;

	var CAST_TYPES = ['mp4', 'webm', 'bmp', 'gif', 'jpeg', 'png', 'webp', 'm3u8', 'cast'];

	Plugin.apply(this, arguments);
	this.namespace = 'chromecast:';

	var CHROMECAST_STATE = 'chromecastState';
	var AVAILABLE = 'available';
	var NOT_AVAILABLE = 'notAvailable';
	var CONNECTED = 'connected';
	var CONNECTING = 'connecting';
	var CHROMECAST_MEDIA = 'chromecastMedia';
	var NEED_TO_CONNECT = 'needToConnect';
	var NEED_TO_DISCONNECT = 'needToDisconnect';
	var HLS = 'hls';

	var _this = this;
	var media = null;
	var session = null;
	var initialized = false;

	this.player.registerProperty(CHROMECAST_STATE, NOT_AVAILABLE, true);

	this.player.on('chromecast', onChromecast);
	this.player.on('chromecastQualityChange', onChromecastQualityChange);

	this.dispose = function () {
		if (session) {
			session.stop();
			session = null;
		}
		media = null;
		_this.player.set(CHROMECAST_MEDIA, null);
		_this.player.set(CHROMECAST_STATE, NOT_AVAILABLE);
	};

	this.load = function (Src, videoInfo) {
		var newSrc = Src || videoInfo.src;
		if (!newSrc || videoInfo && videoInfo.is_live || _this.player.get('epg:currentChannel')) {
			_this.player.set(CHROMECAST_STATE, NOT_AVAILABLE);
			return;
		}

		var ext = _this.player.utils.getExtension(newSrc);
		if (ext === 'm3u8') {
			_this.player.on('player:hls:manifestParsed', onHLSManifestParsed);
		} else {
			_this.player.off('player:hls:manifestParsed', onHLSManifestParsed);
		}

		if (!initialized) {
			if (CAST_TYPES.indexOf(ext) !== -1 && window.chrome && window.chrome.cast) {
				initializeCastApi();
			} else {
				_this.player.set(CHROMECAST_STATE, NOT_AVAILABLE);
			}
		}
	};

	//============CALLBACKS===========
	function onHLSManifestParsed(event) {
		if (event.data && event.data.levels && event.data.levels.length > 1) {
			_this.player.set('hlsBitrates', event.data.levels);

			if (_this.player.get(CHROMECAST_STATE) === CONNECTED) {
				onRequestSessionSuccess(session);
			}
		}
		_this.player.off('player:hls:manifestParsed', onHLSManifestParsed);
	}

	function onChromecast(event) {
		if (event.data === NEED_TO_CONNECT) {
			if (session) {
				_this.player.set(CHROMECAST_STATE, CONNECTING);
				onRequestSessionSuccess(session);
			} else {
				connectToDevice();
			}
		} else if (event.data === NEED_TO_DISCONNECT) {
			var src = _this.player.get('src').replace('.cast', '');
			if (src) {
				var audioTrack = _this.player.get('audioTrack');
				var qualityIndex = -1;
				var qualityList = _this.player.get('qualityList');
				var quality = _this.player.get('quality');
				if (quality != -1) {
					for (var i = 0, l = qualityList.length; i < l; ++i) {
						if (qualityList[i].bitrate == quality) {
							qualityIndex = qualityList[i].index;
							break;
						}
					}
				}
				_this.player.load(src, _this.player.get('videoInfo'), Object.assign({}, _this.player.get('vendorOptions'), {
					startSeconds: _this.player.get('position'),
					quality: qualityIndex,
					defaultAudioTrack: audioTrack
				}));
			}
			if (session) {
				session.stop();
				session = null;
			}
			_this.player.set(CHROMECAST_STATE, AVAILABLE);
		}
	}

	function onChromecastQualityChange(event) {
		if (event.data) {
			var ext = _this.player.utils.getExtension(event.data);
			if (ext === 'm3u8') {
				loadMedia(event.data);
			}
		}
	}

	function onFatalChromecastError(error) {
		_this.player.set(CHROMECAST_MEDIA, null);
		_this.player.set(CHROMECAST_STATE, NOT_AVAILABLE);
		console.log(_this.namespace, error);
	}

	function onRequestSessionSuccess(event) {
		session = event;

		// if (session.media.length > 0) {
		// 	onMediaDiscovered(session.media[0]);
		// } else {
		var src = _this.player.get('src').replace(/\.cast$/, '');
		var quality = _this.player.get('quality');
		if (quality != -1 && _this.player.get('hlsBitrates')) {
			var bitrates = _this.player.get('hlsBitrates');
			if (bitrates && bitrates.length > 1) {
				var bitrate;
				for (var i = 0, l = bitrates.length; i < l; ++i) {
					try {
						bitrate = parseInt(bitrates[i].name);
					} catch (error) {}
					if (quality === bitrate) {
						src = bitrates[i].url[0];
						break;
					}
				}
			}
		}
		loadMedia(src);
		// }
	}

	function onRequestSessionError(event) {
		console.log(_this.namespace, 'session request error:', event.code);

		_this.player.set(CHROMECAST_STATE, AVAILABLE);
	}

	function onMediaDiscovered(newMedia) {
		media = newMedia;
		_this.player.set(CHROMECAST_MEDIA, media);
		_this.player.set(CHROMECAST_STATE, CONNECTED);

		var src;
		if (_this.player.utils.getExtension(_this.player.get('src')) !== 'cast') {
			src = _this.player.get('src') + '.cast';
		} else {
			src = _this.player.get('src');
		}
		_this.player.load(src, _this.player.get('videoInfo'), Object.assign({}, _this.player.get('vendorOptions')));
	}

	//================SERVICE=METHODS===============
	function initializeCastApi() {
		if (!chrome.cast.isAvailable) {
			window['__onGCastApiAvailable'] = function (loaded, error) {
				loaded ? initialize() : onFatalChromecastError();
			};
		} else {
			initialize();
		}

		function initialize() {
			var sessionRequest = new chrome.cast.SessionRequest(chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID);
			var apiConfig = new chrome.cast.ApiConfig(sessionRequest, function (event) {
				//onSessionListener
				console.log(_this.namespace, 'receiver info: success');
			}, function (event) {
				//onReceiverListener
				if (event === chrome.cast.ReceiverAvailability.AVAILABLE) {}
			});

			chrome.cast.initialize(apiConfig, function () {
				//onApiInitialize
				console.log(_this.namespace, 'api initialized');
				initialized = true;
				_this.player.set(CHROMECAST_STATE, AVAILABLE);
			}, function (error) {
				//onApiError
				onFatalChromecastError(error);
			});
		}
	}

	function connectToDevice() {
		_this.player.set(CHROMECAST_STATE, CONNECTING);
		chrome.cast.requestSession(onRequestSessionSuccess, onRequestSessionError);
	}

	function loadMedia(src) {
		var mediaInfo = new chrome.cast.media.MediaInfo(src);
		mediaInfo.contentType = options.mimeType || _this.player.utils.getExtension(src);
		mediaInfo.metadata = new chrome.cast.media.GenericMediaMetadata();
		mediaInfo.metadata.title = _this.player.get('videoInfo').title;

		var mediaRequest = new chrome.cast.media.LoadRequest(mediaInfo);
		mediaRequest.currentTime = _this.player.get('position');
		mediaRequest.autoplay = _this.player.get('state') === 1 || _this.player.get(CHROMECAST_STATE) === CONNECTED;

		session.loadMedia(mediaRequest, onMediaDiscovered, function (error) {
			//onMediaError
			_this.player.set(CHROMECAST_STATE, AVAILABLE);
		});
	}
}

MggpPluginChromecast.prototype.constructor = MggpPluginChromecast;
module.exports = MggpPluginChromecast;

/***/ }),

/***/ "mggp-player":
/*!******************************!*\
  !*** external "mggp-player" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_player__;

/***/ })

/******/ });
});